<template>
  <div class="local-main-page" >
    <ListView ref="list-view" :complex-list="mainData" :option="listOption" @menu="onMenu" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { renderDataType } from 'complex-component/src/antd/data/TableView'
import ListView from '@/components/data/ListView'
import { reactiveLayout } from '@/plugin'
import mainData from './../mainData'
import { toDisposeInfo } from '../disposeFlowConfig'

export default defineComponent({
  name: 'DisposeList',
  components: {
    ListView
  },
  data() {
    return {
      mainData,
      listOption: {
        table: {
          optionProps: {
            bordered: true,
            scroll: {
              x: this.getWidth()
            }
          }
        },
        search: {
          // layout: 'horizontal'
        },
        searchMenu: [
          {
            prop: 'setSearch',
            name: '查询',
            type: 'primary'
          },
          {
            prop: 'resetSearch',
            name: '重置',
            type: 'default'
          }
        ],
        menu: {
          list: [
            {
              prop: 'change-emit',
              name: '详情'
            },
            {
              prop: 'settlement',
              name: '逾期结清',
              hidden({ record }: renderDataType) {
                // 审批状态 = 通过
                if ((record as any).applyStatus.value === '2') {
                  return false
                } else {
                  return true
                }
              }
            },
          ]
        }
      }
    }
  },
  computed: {
    width() {
      return this.getWidth()
    }
  },
  mounted() {
    this.mainData.$loadData(true)
  },
  beforeUnmount() {
    mainData.$reset()
  },
  methods: {
    getWidth() {
      return reactiveLayout.data.main.width - 16 * 2
    },
    onMenu(from: 'search' | 'table', act: string, payload: any) {
      if (from === 'table') {
        if (act === 'change-emit') {
          toDisposeInfo(payload.record.id, '0', 'end')
        } else if (act === 'settlement') {
          this.mainData.$triggerMethod('settleItem', [payload.record])
        }
      }
    }
  }
})
</script>
